import React, { useContext } from 'react';
import { string, arrayOf, shape } from 'prop-types';
import { Button, Col, Row } from '@thd-olt-component-react/core-ui';
import { ProductSetContext } from '../../context/ProductSetContext';
import './swap-back.scss';

export const SwapBack = ({
  swappedProducts,
  productGroup
}) => {
  const { swapGroup } = useContext(ProductSetContext);

  return (
    <Col fallback="11" className="swap-back" data-testid="swap-back">
      <Row className="swap-back__row">
        <span className="swap-back__message">Swap Successful</span>
        <Button
          className="swap-back__button"
          onClick={() => swapGroup(swappedProducts, productGroup)}
          link
        >
          Swap Back
        </Button>
      </Row>
    </Col>
  );
};

SwapBack.propTypes = {
  swappedProducts: arrayOf(shape({})).isRequired,
  productGroup: string.isRequired
};
